import qs from 'qs';
import client from './client';

export const whUuid = '432674D4-C8D8-4F1F-B3EC-84FE401380A0'
const inventoryUrl = '/api/v1/master/wh';

//재고 리스트
export const getInventoryStocks = (params) => {
    const queryString = qs.stringify(params);
    return client.get(`${inventoryUrl}/${whUuid}/list?${queryString}`);
};

//재고 이력 리스트
export const getInventoryHistory = (params) => {
    const queryString = qs.stringify(params);
    return client.get(`${inventoryUrl}/${whUuid}/info?${queryString}`);
};

//재고 상세 보기
export const getTranInfo = (id) => {
    return client.get(`${inventoryUrl}/${whUuid}/info/${id}`);
};

//입고/출고 등록
export const addStockInfo = (dataToSubmit) => {
    return client.post(`${inventoryUrl}/info`, dataToSubmit);
};

///{whUuid}/info/{trnUuid}
export const delTransInfo = (id) => {
    return client.delete(`${inventoryUrl}/${whUuid}/info/${id}`);
};
